'use strict';

var d3 = require('d3');
var _ = require('lodash');

/**
 * Circles
 * @param d3Helper
 * @returns {Function}
 * @constructor
 */
var Circles = function Circles(d3Helper) {
  return function (yPropertyName, radius) {
    var params, scales;

    /**
     *
     * @param container - Element to which circles should be appended
     * @constructs CirclesElement
     */
    var circles = function circles(container) {
      var createVisibleCircles = function createVisibleCircles(groupContainer, circlesData) {
        var cssClass = 'circles';
        var middleOfGroup = params.isSparse ? params.xDataSize / 2 : scales.xScale.rangeBand() / 2;
        var selectedCircles = groupContainer.selectAll('circle.' + cssClass).data(circlesData);
        selectedCircles.enter().append('circle');
        selectedCircles.exit().remove();
        selectedCircles.filter(isTruthyOrZero).attr({
          'class': function _class(d) {
            return cssClass + ' ' + d.css;
          },
          'r': function r(d) {
            return d.radius || radius || Math.min(40, middleOfGroup) / 4;
          }
        });
        selectedCircles.filter(isTruthyOrZero).attr(d3Helper.roundCoordinates({
          'cx': middleOfGroup,
          'cy': function cy(d) {
            return scales.yScale(d.value);
          }
        }, ['cx', 'cy']));
      };
      var groups = container.select('.groups').selectAll('.stack.visible');
      container.selectAll('.circles-group').remove();
      groups.each(function (d) {
        if (!_.isNil(d[yPropertyName])) {
          var circleGroup = d3Helper.createGroupElement(d3.select(this), 'circles-group');
          createVisibleCircles(circleGroup, d[yPropertyName]);
        }
      });
    };
    function isTruthyOrZero(circle) {
      return !!circle.value || circle.value === 0;
    }

    /**
     * Sets/gets circle's params
     * @param {Object} value
     * @returns {circles}
     */
    circles.params = function (value) {
      params = value;
      return circles;
    };

    /**
     * Sets/gets circle's scales
     * @param value
     * @returns {circles}
     */
    circles.scales = function (value) {
      scales = value;
      return circles;
    };
    return circles;
  };
};
Circles.$inject = ['d3Helper'];
module.exports = Circles;